import { render, staticRenderFns } from "./addPatientLayout.vue?vue&type=template&id=ddd72c78&scoped=true"
import script from "./addPatientLayout.vue?vue&type=script&lang=js"
export * from "./addPatientLayout.vue?vue&type=script&lang=js"
import style0 from "./addPatientLayout.vue?vue&type=style&index=0&id=ddd72c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd72c78",
  null
  
)

export default component.exports